import HttpUtil from "../http-handler/http-util";
import API_ROUTES from '../constants/api';

class UOMService {
	// Versions
	static listVersions(companyId = null, fetchAll = false) {
		let url = API_ROUTES.UOM.VERSIONS.LIST;
		const qp = [];
		if (companyId) qp.push(`companyId=${companyId}`);
		if (fetchAll) qp.push(`fetchAll=true`);
		if (qp.length > 0) url = `${url}?${qp.join('&')}`;
		return HttpUtil.get(url);
	}

	static getVersion(versionNumber, companyId = null) {
		let url = API_ROUTES.UOM.VERSIONS.GET.replace("<versionNumber>", versionNumber);
		url = url + (companyId ? (url.includes('?') ? '&' : '?') + 'companyId=' + companyId : '');
		return HttpUtil.get(url);
	}

	static createVersion(payload, companyId = null) {
		let url = API_ROUTES.UOM.VERSIONS.CREATE;
		url = url + (companyId ? `?companyId=${companyId}` : '');
		return HttpUtil.post(url, payload);
	}

	static updateVersion(versionNumber, payload, companyId = null) {
		let url = API_ROUTES.UOM.VERSIONS.UPDATE.replace("<versionNumber>", versionNumber);
		url = url + (companyId ? `?companyId=${companyId}` : '');
		return HttpUtil.put(url, payload);
	}

	static deleteVersion(versionId, companyId = null) {
		let url = API_ROUTES.UOM.VERSIONS.DELETE.replace("<versionId>", versionId);
		url = url + (companyId ? `?companyId=${companyId}` : '');
		return HttpUtil.delete(url);
	}

	static cloneVersion(sourceVersion, companyId = null) {
		let url = API_ROUTES.UOM.VERSIONS.CLONE.replace("<sourceVersion>", sourceVersion);
		url = url + (companyId ? `?companyId=${companyId}` : '');
		return HttpUtil.post(url);
	}

	static exportVersion(versionNumber, companyId = null) {
		let url = API_ROUTES.UOM.VERSIONS.EXPORT.replace("<versionNumber>", versionNumber);
		url = url + (companyId ? `?companyId=${companyId}` : '');
		return HttpUtil.get(url, { responseType: 'blob' });
  }

	static importVersion(versionNumber, formData, companyId = null) {
		let url = API_ROUTES.UOM.VERSIONS.IMPORT.replace("<versionNumber>", versionNumber);
		url = url + (companyId ? `?companyId=${companyId}` : '');
		return HttpUtil.post(url, formData, {
			headers: { 'Content-Type': 'multipart/form-data' }
		});
	}

	// Fetch UOM conversion table for a version/company
	static getConversionTableByVersion(versionNumber, companyId = 0) {
		const url = API_ROUTES.UOM.TABLE.GET_BY_VERSION
			.replace("<versionNumber>", versionNumber)
			.replace("<companyId>", companyId);
		return HttpUtil.get(url);
	}

	// Create a new conversion entry in a specific version/company
	static createConversion(versionNumber, payload, companyId = 0) {
		const url = API_ROUTES.UOM.TABLE.CREATE_CONVERSION
			.replace("<versionNumber>", versionNumber)
			.replace("<companyId>", companyId);
		return HttpUtil.post(url, payload);
	}

	// Update an existing conversion entry by id
	static updateConversion(id, payload) {
		const url = API_ROUTES.UOM.TABLE.UPDATE_CONVERSION.replace("<id>", id);
		return HttpUtil.put(url, payload);
	}

	// Delete a conversion entry by id
	static deleteConversion(id) {
		const url = API_ROUTES.UOM.TABLE.DELETE_CONVERSION.replace("<id>", id);
		return HttpUtil.delete(url);
	}
}

export default UOMService;

